import { getBranchID, getUnitID, getWerehouse } from '@/utils/helper/localStorage'
import moment from 'moment'
const initDataSetOrder = (payload, state, tel = '', billExpire) => {
  let cartList = payload.items
  let price = payload.price
  let sskExpireDate = billExpire || 1
  let expireDate = moment().add(parseInt(sskExpireDate), 'd').format('X')
  let skus = transformCartList(cartList)
  let pendingData = createPendingData(state.type, price, tel)
  let paymentLog = createPaymentLog(state.type, state.total, state.change)
  let discount = calDebt(cartList) - price
  let data = {
    skus,
    debts: [{
      dead_line_date: '',
      debt_balance: price,
      pay_order: 1
    }],
    shipping_type: 'POS',
    discount,
    shipcost: 0,
    bill_expire: parseInt(expireDate),
    pending_data: pendingData,
    pay_order: 1,
    prepare_date: '',
    customer_id: null,
    coupon_id: '',
    unit_id: getUnitID(),
    store_pos_branch_id: getBranchID(),
    payment_log: paymentLog,
    promotion_discount: 0,
    promotions: {}
  }

  let result = {
    data,
    price
  }

  return result
}

function calDebt (cartList) {
  let total = cartList.reduce((sum, item) => sum + parseInt(item.price), 0)
  return total
}

function createPendingData (paymentType, price, tel) {
  let pendingData = {
    customer_name: '',
    customer_address: '',
    customer_postcode: '',
    customer_tel: tel,
    customer_email: '',
    payments: [{
      bill_debt_pay_order: 1,
      date: new Date(),
      amount: parseFloat(price).toFixed(2),
      store_payment_channel_id: paymentType.id,
      attached_slip: '',
      cache_payment_channel_name: paymentType.payment_name,
      cache_payment_channel_id: paymentType.payment_channel_id,
      cache_payment_channel_logo: paymentType.logo,
      cache_payment_channel_type: paymentType.payment_name.toLowerCase(),
      cache_store_payment_channel_credential: '{}'
    }]
  }
  return pendingData
}

function createPaymentLog (paymentType, receivedMoney, change) {
  let paymentLog = {
    recivePayment: parseFloat(receivedMoney).toFixed(2),
    changePayment: parseFloat(change).toFixed(2),
    payments: [{
      id: paymentType.id,
      name: paymentType.payment_name,
      logo: paymentType.logo,
      payment_channel_id: paymentType.payment_channel_id,
      payment_channel_name: paymentType.payment_name,
      payment_channel_type: paymentType.payment_name.toLowerCase(),
      payment_channel_logo: paymentType.logo,
      credential: '{}',
      value: '99'
    }]
  }
  return paymentLog
}

function transformCartList (cartList) {
  let skus = []
  cartList.map(item => {
    skus.push({
      product_id: item.product_id,
      brand_name: '',
      code: '',
      id: item.id,
      price: item.price,
      stock_lot: item.remain,
      skuStatus: '1',
      name: item.name,
      description: '',
      variants: ['SKU', '', ''],
      concat_sku_options: item.optionPOSCompleteCart,
      concatSkuOptions: [],
      sku_src: item.image,
      options: 'default  ',
      warehouse: getWerehouse(),
      amount: 1,
      discount: {
        type: 'percentageOff',
        value: 10
      },
      fullPrice: item.price,
      isManualDiscount: false
    })
  })
  return skus
}

export {
  initDataSetOrder
}



// WEBPACK FOOTER //
// ./src/utils/modules/payment.js